import { render, staticRenderFns } from "./AccountTeaser.vue?vue&type=template&id=a8200838&scoped=true"
import script from "./AccountTeaser.js?vue&type=script&lang=js&external"
export * from "./AccountTeaser.js?vue&type=script&lang=js&external"
import style0 from "./AccountTeaser.scss?vue&type=style&index=0&id=a8200838&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8200838",
  null
  
)

export default component.exports